
export default () => {
    return new Promise((resolve, reject) => {
        let startTime, endTime, fileSize, speedInMbps;
    
        const xhr = new XMLHttpRequest();
    
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
    
            endTime = (new Date()).getTime();
    
            fileSize = xhr.responseText.length;
    
            speedInMbps = ((fileSize * 8) / ((endTime - startTime) / 1000) / 1024) / 1000;

            resolve(speedInMbps)
          }
        }

        xhr.onerror = () => {
            reject()
        }
    
        startTime = (new Date()).getTime();
    
        xhr.open("GET", process.env.PROBE_FILE_URL, true);
        xhr.send();
    })
}


// WEBPACK FOOTER //
// ./src/utils/bandwidth.js